// Module
var code = `<div class="doc-editor">
    <div class="editor-container">
        <textarea class="editor-textarea"></textarea>
    </div>
</div>
`;
// Exports
export default code;